import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../cx';

export function Label({
  children,
  tone,
  className,
  ...rest
}: { tone?: 'strong' | 'accent'; children: ReactNode } & HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={cx('rr-label', tone && `rr-label--${tone}`, className)} {...rest}>
      {children}
    </span>
  );
}

export function Display({ children, className, ...rest }: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h1 className={cx('rr-display', className)} {...rest}>
      {children}
    </h1>
  );
}

export function Title({ children, className, ...rest }: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h1 className={cx('rr-title', className)} {...rest}>
      {children}
    </h1>
  );
}

export function Heading({ children, className, ...rest }: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h2 className={cx('rr-heading', className)} {...rest}>
      {children}
    </h2>
  );
}

export function Serif({
  children,
  italic,
  className,
  ...rest
}: { italic?: boolean } & HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={cx('rr-serif', italic && 'rr-serif--italic', className)} {...rest}>
      {children}
    </span>
  );
}
